import { createRequestId, postEmailRequest } from './emailApi'

const newsletterEmailEndpoint = process.env.REACT_APP_NEWSLETTER_EMAIL_ENDPOINT || '/api/send-newsletter-email.php'

const normalizeEmail = (email) => String(email || '').trim().toLowerCase()

export async function submitNewsletterSubscription(email, website = '') {
    const normalizedEmail = normalizeEmail(email)

    if (!normalizedEmail) {
        throw new Error('Please enter your email address.')
    }

    await postEmailRequest(
        newsletterEmailEndpoint,
        { email: normalizedEmail, website, requestId: createRequestId() },
        'Newsletter email service'
    )

    return normalizedEmail
}
